module.exports = __webpack_public_path__ + "static/media/self-guru-grou-novo.f507ec3a.png";